import {Component, Injectable,Input,Output,EventEmitter} from '@angular/core';
import { ActivatedRoute, Router  } from '@angular/router';
import {  HttpHeaders } from '@angular/common/http';
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';


@Injectable({
  providedIn: 'root'
})
export class SharedService {
    @Output() loginChk: EventEmitter<any> = new EventEmitter();
    @Output() username: EventEmitter<any> = new EventEmitter();
    @Output() loginUserId: EventEmitter<any> = new EventEmitter();
    @Output() role: EventEmitter<any> = new EventEmitter();
    @Output() profilePic: EventEmitter<any> = new EventEmitter();
    @Output() notify: EventEmitter<any> = new EventEmitter();
    @Output() currentVerion: EventEmitter<any> = new EventEmitter();
    @Output() cmAccess: EventEmitter<any> = new EventEmitter();
    @Output() userLeadSource: EventEmitter<any> = new EventEmitter();

    allData: any = [];
    horizontalPosition: MatSnackBarHorizontalPosition = 'end';
    verticalPosition: MatSnackBarVerticalPosition = 'top';
   constructor(private router:Router,private _snackBar: MatSnackBar) {

   }

    getHeaders()
    {
        let authkey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJnbGFteW9jcm0iLCJuYW1lIjoiR2xhbXlvIiwiaWF0IjoxNjE2MjM5MDIyfQ.Q5uHQTY9IoFAC-nNdamUqd925qt5GQ-wuZZTSZcZSiQ';
        if(localStorage.getItem('currentUser'))
        {
            return new HttpHeaders({ 'Authorization': 'Bearer '+authkey,'TOKEN':localStorage.getItem('currentUser')});
        }else{
            return new HttpHeaders({ 'Authorization': 'Bearer '+authkey});
        }
    }

    getHeadersForUpload()
    {
        let authkey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJnbGFteW9jcm0iLCJuYW1lIjoiR2xhbXlvIiwiaWF0IjoxNjE2MjM5MDIyfQ.Q5uHQTY9IoFAC-nNdamUqd925qt5GQ-wuZZTSZcZSiQ';
        if(localStorage.getItem('currentUser'))
        {
            return { 'Authorization': 'Bearer '+authkey,'TOKEN':localStorage.getItem('currentUser')};
        }else{
        return { 'Authorization': 'Bearer '+authkey};
        }
    }

    setlogin(value)
    {
        this.loginChk.emit(value);
    }

    getLoginchk()
    {
        return this.loginChk;
    }

    setUserId(value)
    {
        this.loginUserId.emit(value);
    }

    getUserId()
    {
        return this.loginUserId;
    }
    setCMAccess(value)
    {
        this.cmAccess.emit(value);
    }

    setLeadSourceOfUse(value)
    {
        this.userLeadSource.emit(value);
    }

    getCMAccess()
    {
        return this.cmAccess;
    }

    getLeadSourceOfUser()
    {
        return this.userLeadSource;
    }

    setUsername(value)
    {
        this.username.emit(value);
    }

    getUsername()
    {
        return this.username;
    }

    setProfilePic(value)
    {
        this.profilePic.emit(value);
    }

    getProfilePic()
    {
        return this.profilePic;
    }

    setRole(value)
    {
        this.role.emit(value);
    }

    getRole()
    {
        return this.role;
    }

    setNotificationPush(value)
    {
        this.notify.emit(value);
    }

    getNotificationPush()
    {
        return this.notify;
    }

    // setting value for mismatch app version to refresh window
    setNotificationKey(value)
    {
        this.currentVerion.emit(value);
    }

    // setting value for mismatch app version to refresh window
    getNotificationKey()
    {
        return this.currentVerion;
    }

    getStatus(Srcstatus)
    {
        let status = 'NA';
        switch(Srcstatus)
        {
            case 0:
            status = 'Active';
            break;
            case 1:
            status = 'Completed';
            break;
            case 3:
            status = 'Cancelled';
            break;
            case 4:
            status = 'Postponed';
            break;
        }
        return status;
    }

    getRoomCategory(room)
    {
        let roomtype = 'NA';
        switch(room)
        {
            case 1:
            roomtype = 'Single Private';
            break;
            case 2:
            roomtype = 'Double Sharing';
            break;
            case 3:
            roomtype = 'General Ward';
            break;
            case 4:
            roomtype = 'Three Sharing';
            break;
            case 5:
            roomtype = 'As per Insurance T&C';
            break;
            case 6:
            roomtype = 'Day Care';
            break;
        }
        return roomtype;
    }

    getPaymentType(payment_type)
    {
        let paytype = 'NA';
        switch(payment_type)
        {
            case 1:
            paytype = 'Cash';
            break;
            case 2:
            paytype = 'Cashless';
            break;
            case 3:
            paytype = 'Reimbursement';
            break;
            case 4:
            paytype = 'EMI';
            break;
        }
        return paytype;
    }

    getLeadSource(source)
    {
        let sourceName = 'NA';
        switch(source)
        {
            case 1:
            sourceName = 'Forms';
            break;
            case 2:
            sourceName = 'Kaleyra';
            break;
            case 3:
            sourceName = 'Practo';
            break;
            case 4:
            sourceName = 'Consult Now';
            break;
            case 5:
            sourceName = 'Lead Gen-FB';
            break;
            case 6:
            sourceName = 'Youtube';
            break;
            case 7:
            sourceName = 'Referral';
            break;
            case 8:
            sourceName = 'Blogs';
            break;
            case 9:
            sourceName = 'Medife';
            break;
            case 10:
            sourceName = 'Google Business Page';
            break;
            case 11:
            sourceName = 'LP-FB';
            break;
            case 12:
            sourceName = 'Surgical Dial';
            break;
            case 13:
            sourceName = 'Medife FB';
            break;
            case 14:
            sourceName = 'Just Dial';
            break;
            case 15:
            sourceName = 'Taboola';
            break;
            case 16:
            sourceName = 'Whatsapp';
            break;
            case 17:
            sourceName = 'Compititor';
            break;
            case 18:
            sourceName = 'True Cover';
            break;
            case 19:
            sourceName = 'Paytm';
            break;
            case 20:
            sourceName = 'Fb-Kalera';
            break;
            case 21:
            sourceName = 'Wp-Form';
            break;
            case 22:
            sourceName = 'Brand Fb-Source';
            break;
            case 23:
            sourceName = 'PMax';
            break;
            case 24:
            sourceName = 'Docknee';
            break;
            case 25:
            sourceName = 'Adyll';
            break;
            case 26:
            sourceName = 'Sulekha';
            break;
            case 27:
            sourceName = 'Snapchat';
            break;
            case 28:
            sourceName = 'Corporate Lead';
            break;
            case 29:
            sourceName = 'Instagram';
            break;
            case 30:
            sourceName = 'Google Pay';
            break;
            case 31:
            sourceName = 'Phone Pay';
            break;
            case 32:
            sourceName = 'MediBuddy';
            break;
            case 33:
            sourceName = 'App';
            break;
            case 34:
            sourceName = 'GP Channel';
            break;
            case 35:
            sourceName = 'Affinity Referral';
            break;
            case 36:
            sourceName = 'Discovery';
            break;
            case 37:
            sourceName = 'Secure Now';
            break;
            case 38:
            sourceName = 'FB-Retail';
            break;
            case 39:
            sourceName = 'Healthy Sure';
            break;
            case 40:
            sourceName = 'Lab Leads';
            break;
            case 41:
            sourceName = 'System Generated';
            break;
            case 42:
            sourceName = 'Vesta Elder Care';
            break;
            case 43:
            sourceName = 'Truventiv';
            break;
            case 44:
            sourceName = 'Watchful Eye';
            break;
            case 45:
            sourceName = 'Affiliate';
            break;
            case 46:
            sourceName = 'FB Organic';
            break;
            case 47:
            sourceName = 'Patient Referral';
            break;
            case 48:
            sourceName = 'Cred';
            break;
            case 49:
            sourceName = 'Myupchar';
            break;
            case 50:
            sourceName = 'Value Leaf';
            break;
            case 51:
            sourceName = 'Bestosys Partner';
            break;
        }
        return sourceName;
    }

    checkError(error)
    {
        if(error.error.err=='session')
        {
            this.presentToast('Session Expired!');
            localStorage.clear();
            this.setlogin(false);
            this.router.navigate(['login']);
        }
        else{
            this.presentToast('Something went wrong, Try Again!');
        }
    }

    presentToast(msg,duration=5000)
    {
        this._snackBar.open(msg, 'close', {
            duration: duration,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
        });
    }

    searchData(query: string, alldata, field) {
		this.allData = alldata;
		if (query != '') {
			let result = this.selectSearch(query, field);
			return result;
		} else {
			return alldata;
		}
	}

	selectSearch(query: string, field): string[] {
		let result: string[] = [];
		for (let a of this.allData) {
            if (a[field].toLowerCase().indexOf(query.toLowerCase()) > -1) {
                result.push(a)
            }
		}
		return result;
	}
}
